/**
 * Numbering follows the boxes on the ICS 233-CG form, as printed by
 * `services/coms/src/routes/Forms/ICS_CG/forms/ICS233CG.ts`.
 *
 * Boxes 1-3 are the read-only header the card renders as its own sections.
 * Boxes 4-10 are columns of the single action table rather than sections, so
 * they are listed separately in `ICS233_PRINTED_COLUMNS`.
 *
 * The form has no prepared-by or signature box, and must not gain one: the
 * descriptor declares none, which is what leaves its versions unsignable.
 */
export const ICS233_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  actions: '4-10. Open Actions:',
} as const;

/**
 * What each printed column holds, which is not always what the card's table
 * shows under the same heading.
 *
 * Worth keeping written down: the export merges name and description into one
 * cell, numbers rows by position rather than by the action's display id, and
 * prints the point of contact where the screen shows the assignee.
 */
export const ICS233_PRINTED_COLUMNS = [
  { box: 4, label: '#', source: 'Row position on the page, not display_id' },
  { box: 5, label: 'Item / Task', source: 'name, then " - description"' },
  { box: 6, label: 'Point of Contact', source: 'poc_user_name' },
  { box: 7, label: 'POC Briefed', source: 'briefed_poc, as Yes or No' },
  { box: 8, label: 'Start Date', source: 'start_date' },
  { box: 9, label: 'Deadline', source: 'target_date' },
  { box: 10, label: 'Status', source: 'status' },
] as const;

export const ICS233_INCIDENT_NAME_HINT =
  'This box is read-only. It is filled from the incident name.';

/** Mirrors `resolveOperationalPeriodValues`, which the PDF export uses. */
export const ICS233_INCIDENT_LOCATION_HINT =
  'This box is read-only. It is filled from the incident location, falling back to the address set when the incident was created.';

export const ICS233_OPERATIONAL_PERIOD_HINT =
  'Click this box to set the scheduled start and end of the next operational period for this incident workspace. Working-period forms print that window, and the export lists the actions that fall inside it.';
